exports.version = "0.5.26"


/*****************
 ** WEBPACK FOOTER
 ** ./~/apollo-client/version.js
 ** module id = 878
 ** module chunks = 0
 **/